var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H11C8.79086 19 7 17.2091 7 15V5C7 2.79086 8.79086 1 11 1H17C19.2091 1 21 2.79086 21 5V12M1 5H4M11 5H17M11 9H17M11 13H14M15 17L16.7528 18.4023C17.1707 18.7366 17.7777 18.6826 18.1301 18.2799L21 15M2.5 19L3.2 18.0667C3.71929 17.3743 4 16.5321 4 15.6667V2.5C4 1.67157 3.32843 1 2.5 1C1.67157 1 1 1.67157 1 2.5V15.6667C1 16.5321 1.28071 17.3743 1.8 18.0667L2.5 19Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplications);
export default __webpack_public_path__ + "static/media/job-applications.7711bf1c31d1943062d97e86279afe91.svg";
export { ForwardRef as ReactComponent };